import {create} from 'zustand';
import { IInterlocuteur } from '../interfaces/crm';

interface CrmState {
    tabCRM: string;
    setTabCRM: (tabCRM: string) => void;

    formData: Record<string, any>;
    setFormData: (formData: Record<string, any>) => void;

    billingContacts: IInterlocuteur[];
    setBillingContacts: (billingContacts: IInterlocuteur[]) => void;

    clientName: string;
    setClientName: (clientName: string) => void;

    juridicsForm: { label: string; value: string }[];
    setJuridicsForm: (juridicsForm: { label: string; value: string }[]) => void;

    mandate: {RUM: string, dateSignature: string, active: boolean};
    setMandate: (mandate: {RUM: string, dateSignature: string, active: boolean}) => void;

    clientFiles: any[];
    setClientFiles: (clientFiles: any[]) => void;

    viewOrUpdate : string;
    setViewOrUpdate: (viewOrUpdate: string) => void;

    departments: any[];
    setDepartments: (departments: any[]) => void;

    idCustomer: number;
    setIdCustomer: (idCustomer: number) => void;

    billingFrequencies: any[];
    setBillingFrequencies: (billingFrequencies: any[]) => void;

    missions: any[];
    setMissions: (missions: any[]) => void;

    idMission: number;
    setIdMission: (idMission: number) => void;

    dataFilter: any[];
    setDataFilter: (dataFilter: any[]) => void;

    dataFilterMission: any[];
    setDataFilterMission: (dataFilterMission: any[]) => void;

    dataFilterDocument: any[];
    setDataFilterDocument: (dataFilterDocument: any[]) => void;

    docModels: {label: string, value: string}[];
    setDocModels: (docModels: {label: string, value: string}[]) => void;

    updateCrm: boolean;
    setUpdateCrm: (updateCrm: boolean) => void;

    documents: any[];
    setDocuments: (documents: any[]) => void;

    currentPage: number;
    setCurrentPage: (currentPage: number) => void;

    discount: any[];
    setDiscount: (discount: any[]) => void;

    typeStructure: any[];
    setTypeStructure: (typeStructure: any[]) => void;

    resetCrm: () => void;
}

export const useCrmStore = create<CrmState>((set) => ({
    tabCRM: 'Dossier clients',
    setTabCRM: (tabCRM) => set({tabCRM}),

    formData: {},
    setFormData: (formData) => set({formData}),

    billingContacts: [{clientAccess: false, email: ''}],
    setBillingContacts: (billingContacts) => set({billingContacts}),

    clientName: '',
    setClientName: (clientName) => set({clientName}),

    juridicsForm: [],
    setJuridicsForm: (juridicsForm) => set({juridicsForm}),

    mandate: {RUM: '', dateSignature: '', active: false},
    setMandate: (mandate) => set({mandate}),

    clientFiles: [],
    setClientFiles: (clientFiles) => set({clientFiles}),

    viewOrUpdate: '',
    setViewOrUpdate: (viewOrUpdate) => set({viewOrUpdate}),

    idCustomer: 0,
    setIdCustomer: (idCustomer) => set({idCustomer}),

    departments: [],
    setDepartments: (departments) => set({departments}),

    billingFrequencies: [],
    setBillingFrequencies: (billingFrequencies) => set({billingFrequencies}),

    missions: [],
    setMissions: (missions) => set({missions}),

    idMission: 0,
    setIdMission: (idMission) => set({idMission}),

    dataFilter: [],
    setDataFilter: (dataFilter) => set({dataFilter}),

    dataFilterMission: [],
    setDataFilterMission: (dataFilterMission) => set({dataFilterMission}),

    dataFilterDocument: [],
    setDataFilterDocument: (dataFilterDocument) => set({dataFilterDocument}),

    docModels: [],
    setDocModels: (docModels) => set({docModels}),

    updateCrm: false,
    setUpdateCrm: (updateCrm) => set({updateCrm}),

    documents: [],
    setDocuments: (documents) => set({documents}),

    currentPage: 1,
    setCurrentPage: (currentPage) => set({currentPage}),

    discount: [],
    setDiscount: (discount) => set({discount}),

    typeStructure: [],
    setTypeStructure: (typeStructure) => set({typeStructure}),

    resetCrm: () => set((state) => ({
        tabCRM: 'Dossier clients',
        formData: {},
        billingContacts: [{clientAccess: false, email: ''}],
        clientName: '',
        juridicsForm: [],
        mandate: {RUM: '', dateSignature: '', active: false},
        clientFiles: [],
        missions: [],
        viewOrUpdate: '',
        idCustomer: 0,
        idMission: 0,
        departments: [],
        billingFrequencies: [],
        dataFilter: [],
        dataFilterMission: [],
        docModels: [],
        updateCrm: false,
        documents: [],
        dataFilterDocument: [],
        discount: [],
        typeStructure: [],
        currentPage: state.tabCRM === 'Dossier clients' ? state.currentPage : 1,
    })),
}));
